module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-x-fill-662a049b.svg";